import React, { useCallback } from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainNoticeList.module.scss'

import MyhouseMainNoticeItem from '@Components/atoms/MyhouseMainNoticeItem'
import MyHouseNoticeSummaryResponse from '@Types/entities/MyHouseNoticeSummaryResponse'
import useBoard from '@Hooks/myhouse/board/useBoard'
import { MY_HOUSE_NOTICE_CATEGORY, MY_HOUSE_NOTICE_CATEGORY_OBJ } from '@Root/contants/myhouse'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'

const cx = className.bind(style)

type Props = {
  list: MyHouseNoticeSummaryResponse[]
  complexNo: number
}

const MyhouseMainNoticeList: React.FC<Props> = ({ list, complexNo }: Props) => {
  const { isRecent, isVisited, getSimplifiedDate } = useBoard()

  return (
    <>
      {/* [D] list 로 되어있을 때 빈 배열이어도 ul 태그가 렌더링되는 것 같아 수정  */}
      {list.length > 0 && (
        <ul className={cx('myhouse_notice_list')}>
          {list
            ?.filter((e, i) => i < 4)
            .map(({ sequence, isAttention, category, title, modifiedDate, readCount, imageUrl }) => {
              const noticeItem = {
                title,
                isRecent: isRecent(modifiedDate),
                isVisited: isVisited(sequence),
                category: MY_HOUSE_NOTICE_CATEGORY_OBJ[category as MY_HOUSE_NOTICE_CATEGORY].SUMMARY_LABEL,
                date: getSimplifiedDate(modifiedDate),
                view: readCount,
                href: `${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/notices/${sequence}`,
                imageUrl: imageUrl,
              }
              return <MyhouseMainNoticeItem key={sequence} isAttention={isAttention} {...noticeItem} />
            })}
        </ul>
      )}
    </>
  )
}

export default MyhouseMainNoticeList
